<!-- components/ChapterModal.vue -->
<template>
  <div v-if="modelValue" class="modal-overlay">
    <div class="modal-content">
      <h5 class="mb-3">
        {{
          mode === "edit"
            ? currentLang.btnEditChapter
            : currentLang.btnAddChapters
        }}
      </h5>

      <div class="mb-3">
        <label class="form-label">{{ currentLang.labelNameFa }}</label>
        <span class="required">*</span>
        <input
          required
          v-model.trim="nameFa"
          class="form-control"
          :placeholder="currentLang.placeholderNameFa"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">{{ currentLang.labelNameEn }}</label>
        <span class="required">*</span>
        <input
          required
          v-model.trim="nameEn"
          class="form-control"
          :placeholder="currentLang.placeholderNameEn"
        />
      </div>

      <div class="mt-3 d-flex gap-2 justify-content-end">
        <button class="btn btn-secondary" @click="close">
          {{ currentLang.back }}
        </button>
        <button class="btn btn-primary" @click="save" :disabled="submitting">
          <span v-if="submitting">{{ currentLang.saving }}</span>
          <span v-else>{{ currentLang.save }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import api from "@/plugins/axios";
import { lang } from "@/plugins/lang";
import { alertStore } from "@/stores/alertStore";

import enText from "@/locales/en/chapters";
import faText from "@/locales/fa/chapters";

const translations = { en: enText, fa: faText };
const currentLang = computed(() => translations[lang.value]);

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  mode: { type: String, default: "create" }, // 'create' | 'edit'
  targetItem: { type: Object, default: null }, // سرفصل انتخاب شده برای ویرایش
  productId: { type: [String, Number], required: true },
});

const emit = defineEmits(["update:modelValue", "refresh"]);

const nameFa = ref("");
const nameEn = ref("");
const submitting = ref(false);

// وقتی targetItem یا mode عوض شد، فرم را تنظیم کن
watch(
  () => [props.targetItem, props.mode, props.modelValue],
  ([item, mode, open]) => {
    if (!open) return;
    if (mode === "edit" && item) {
      nameFa.value = item.name_fa || "";
      nameEn.value = item.name_en || "";
    } else {
      nameFa.value = "";
      nameEn.value = "";
    }
  },
  { immediate: true }
);

const close = () => {
  emit("update:modelValue", false);
};

const save = async () => {
  submitting.value = true;

  try {
    if (props.mode === "edit" && props.targetItem) {
      const response = await api.patch(
        `/admin/products/chapter/${props.targetItem.id}`,
        {
          name_fa: nameFa.value,
          name_en: nameEn.value,
        }
      );
      alertStore.trigger(
        "success",
        currentLang.value.success,
        response.data.message
      );
    } else {
      const response = await api.post(
        `/admin/products/${props.productId}/chapters`,
        {
          name_fa: nameFa.value,
          name_en: nameEn.value,
        }
      );
      alertStore.trigger(
        "success",
        currentLang.value.success,
        response.data.message
      );
    }

    emit("refresh");
    close();
  } catch (e) {
    alertStore.trigger(
      "error",
      currentLang.value.error,
      e.response.data.message
    );
  } finally {
    submitting.value = false;
  }
};
</script>




<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.5rem;
  min-width: 320px;
  max-width: 420px;
}
.required {
  color: red;
  margin-right: 4px;
}
</style>

